<template>
  <p class="socialMediaIcons">
    <a href="https://www.facebook.com/EatsOnFeetsHome/" target="_blank" title="Visit Us On Facebook">
      <img src="https://www.eatsonfeetsresources.org/wp-content/plugins/floating-social-media-icon/images/themes/25/facebook.png" style="border:0px;" alt="Visit Us On Facebook" height="32px" width="32px">
    </a>
    <a href="https://www.instagram.com/eatsonfeetshome/" target="_blank" title="Visit Us On Instagram">
      <img src="https://www.eatsonfeetsresources.org/wp-content/plugins/floating-social-media-icon/images/themes/25/instagram.png" style="border:0px;" alt="Visit Us On Instagram" height="32px" width="32px">
    </a>
     <a href="https://www.pinterest.com/eatsonfeets/_saved/" target="_blank" title="Visit Us On Pinterest">
      <img src="https://www.eatsonfeetsresources.org/wp-content/plugins/floating-social-media-icon/images/themes/25/pinterest.png" style="border:0px;" alt="Visit Us On Pinterest" height="32px" width="32px">
    </a>
    <a href="https://www.youtube.com/channel/UCLvPZmEtTPPxwh_Y7lJQ4zw" target="_blank" title="Visit Us On Youtube">
      <img src="https://www.eatsonfeetsresources.org/wp-content/plugins/floating-social-media-icon/images/themes/25/youtube.png" style="border:0px;" alt="Visit Us On Youtube" height="32px" width="32px">
    </a></p>
</template>
<script>
export default {
  name: 'SocialMediaIconBar'
}
</script>
<style lang="scss" scoped>
.socialMediaIcons {
}
</style>
